"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var splitDateDataByFormat = _spauiUtils.date.splitDateDataByFormat,
    joinDateDataToFormat = _spauiUtils.date.joinDateDataToFormat; // 转化成数字

var toInt = function toInt(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return parseInt(value, 10) || defaultValue;
};
/**
 * @class
 */


var MonthArea =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(MonthArea, _PureComponent);

  /**
   * 组件属性说明
   * @property {array} value=[] 值
   * @property {array} keyday=[] 关键日期
   * @property {func} onChange 回调
   * @property {number} year=0 年
   * @property {number} month=0 月
   * @property {object} optionalStartDateData={} 可选开始日期
   * @property {object} optionalEndDateData={} 可选结束日期
   * @property {string} type='' 类型
   * @property {bool} [disabled=false] 是否禁用
   * @property {string} [format='XXXX-XX-XX'] 日期格式
   * @example
   * value=['2018-08-01', ['2018-08-08', '2018-08-15']]
   */
  function MonthArea(props) {
    var _this;

    _classCallCheck(this, MonthArea);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MonthArea).call(this, props));
    _this.isMouseDown = false;
    _this.startData = {};
    _this.endData = {}; // 根据已选日期生成日期列表

    _this.state = {
      valueList: _this.getRoutineList({
        value: props.value,
        format: props.format
      }),
      keydayList: _this.getRoutineList({
        value: props.keyday,
        format: props.format
      })
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_this));
    _this.handleMouseMove = _this.handleMouseMove.bind(_assertThisInitialized(_this));
    _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_this));
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MonthArea, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // 有值就重新设置
      this.setState({
        valueList: this.getRoutineList({
          value: nextProps.value,
          format: nextProps.format
        }),
        keydayList: this.getRoutineList({
          value: nextProps.keyday,
          format: nextProps.format
        })
      });
    } // 当前点击对应的日期的年月日

  }, {
    key: "getTargetData",
    value: function getTargetData(event) {
      return {
        year: toInt(event.target.getAttribute('data-year')),
        month: toInt(event.target.getAttribute('data-month')),
        date: toInt(event.target.getAttribute('data-date'))
      };
    } // 是否对应的目标对象是禁用的

  }, {
    key: "isDisabled",
    value: function isDisabled(event) {
      var disabled = this.props.disabled;
      return disabled || !!event.target.getAttribute('data-disabled');
    } // 两个object对象是否相等

  }, {
    key: "isEqualForObjectData",
    value: function isEqualForObjectData() {
      var fromData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var toData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var result = false;
      var key = '';
      var fromLen = 0;
      var toLen = 0;

      if (_typeof(fromData) === 'object' && _typeof(toData) === 'object') {
        result = true;

        for (key in fromData) {
          if (typeof fromData[key] !== 'undefined') {
            fromLen = fromLen + 1;

            if (fromData[key] !== toData[key]) {
              result = false;
            }
          }
        }

        for (key in toData) {
          if (typeof toData[key] !== 'undefined') {
            toLen = toLen + 1;
          }
        }

        if (fromLen !== toLen) {
          result = false;
        }
      }

      return result;
    } // 根据开始与结束日期生成日期列表，比如{'2019-03-02': {year: 2019, month: 2, date: 2}}

  }, {
    key: "getRoutineListByStartAndEndData",
    value: function getRoutineListByStartAndEndData(startData, endData) {
      var format = this.props.format;
      var result = {};
      var startDate = toInt(startData.date);
      var endDate = toInt(endData.date);
      var tempDate = 0;
      var tempData = {}; // 判断下日期大小

      if (startDate > endDate) {
        tempDate = startDate;
        startDate = endDate;
        endDate = tempDate;
      } // 日期范围暂时只能传同个月的


      if (startData.year === endData.year && startData.month === endData.month) {
        for (; startDate <= endDate; startDate++) {
          tempData = {
            year: startData.year,
            month: startData.month,
            date: startDate
          };
          result[joinDateDataToFormat(tempData, format)] = tempData;
        }
      }

      return result;
    } // 生成日期列表

  }, {
    key: "getRoutineList",
    value: function getRoutineList() {
      var _this2 = this;

      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _props$value = props.value,
          value = _props$value === void 0 ? [] : _props$value,
          format = props.format;
      var result = {};
      var startData = {};
      var endData = {};
      var key = '';
      var listData = {};
      value.map(function (item) {
        // 数组且是双日期都有值
        if ((0, _spauiUtils.isArray)(item) && item.length === 2 && item[0] && item[1]) {
          // 开始日期
          startData = splitDateDataByFormat(item[0], format); // 结束日期

          endData = splitDateDataByFormat(item[1], format); // 生成日期列表

          listData = _this2.getRoutineListByStartAndEndData(startData, endData);

          for (key in listData) {
            if (listData[key]) {
              result[key] = (0, _spauiUtils.objectAssign)(listData[key]);
            }
          }
        } else if (typeof item === 'string' && item) {
          result[item] = splitDateDataByFormat(item, format);
        }

        return item;
      });
      return result;
    } // 获取对应日期的状态

  }, {
    key: "getDateStatus",
    value: function getDateStatus() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$state = this.state,
          valueList = _this$state.valueList,
          keydayList = _this$state.keydayList;
      var _this$props = this.props,
          value = _this$props.value,
          format = _this$props.format;
      var theDate = joinDateDataToFormat(data, format);
      var valueStringList = [];
      var result = '';
      value.map(function (item) {
        if ((0, _spauiUtils.isArray)(item) && item.length === 2) {
          valueStringList.push(item[0]);
          valueStringList.push(item[1]);
        } else if (typeof item === 'string' && item) {
          valueStringList.push(item);
        }

        return item;
      });

      if ((0, _spauiUtils.indexOf)(valueStringList, theDate) > -1 && valueList[theDate]) {
        result = 'on';
      } else if (valueList[theDate]) {
        result = 'among';
      }

      if (result && keydayList[theDate]) {
        result = 'keyday';
      }

      return result;
    }
  }, {
    key: "handleChange",
    value: function handleChange() {
      var _this$props2 = this.props,
          onChange = _this$props2.onChange,
          format = _this$props2.format,
          year = _this$props2.year,
          month = _this$props2.month;
      var _this$state2 = this.state,
          valueList = _this$state2.valueList,
          stateKeyDayList = _this$state2.keydayList;

      var getContinueValue = function getContinueValue(data, index, result) {
        var len = data.length;
        var startDate = 0;
        var endDate = 0;
        var i = index + 1;
        var currentIndex = index;

        if (index < len) {
          startDate = data[index].date;
          endDate = data[index].date;

          for (; i < len; i++) {
            if (data[i].date - data[i - 1].date !== 1) {
              endDate = data[i - 1].date;
              currentIndex = i;
              break;
            } else if (i === len - 1) {
              endDate = data[i].date;
              currentIndex = len;
            }
          }

          if (startDate === endDate) {
            result.push(joinDateDataToFormat(data[index], format));
            getContinueValue(data, i, result);
          } else if (startDate !== endDate) {
            result.push([joinDateDataToFormat(data[index], format), joinDateDataToFormat(data[currentIndex - 1], format)]);
            getContinueValue(data, currentIndex, result);
          }
        }

        return result;
      };

      var addData = function addData() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var curData = arguments.length > 1 ? arguments[1] : undefined;
        var result = data;
        var curIndex = -1;

        if (data.length < 1) {
          result.push(curData);
        } else {
          data.map(function (item, index) {
            if (item.date > curData.date && curIndex < 0) {
              curIndex = index;
            }

            return item;
          });

          if (curIndex === 0) {
            result.unshift(curData);
          } else if (curIndex > 0) {
            result = result.slice(0, curIndex).concat([curData]).concat(result.slice(curIndex));
          } else {
            result.push(curData);
          }
        }

        return result;
      };

      var newVlaue = [];
      var newKeyDay = [];
      var keydayList = {};
      var valueData = [];
      var keydayData = [];
      var key = ''; // keyday 只保留在value里面有的

      for (key in stateKeyDayList) {
        if (valueList[key]) {
          keydayList[key] = stateKeyDayList[key];
        }
      } // 转成数组


      for (key in valueList) {
        if (valueList[key]) {
          valueData = addData(valueData, valueList[key]);
        }
      } // 转成数组


      for (key in keydayList) {
        if (keydayList[key]) {
          keydayData = addData(keydayData, keydayList[key]);
        }
      } // 转换成连续性的值


      getContinueValue(valueData, 0, newVlaue); // 转换成连续性的值

      getContinueValue(keydayData, 0, newKeyDay);

      if ((0, _spauiUtils.isFunction)(onChange)) {
        onChange(year, month, newVlaue, newKeyDay);
      }
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      var targetData = this.getTargetData(event); // 非禁用且有日期的才能按下去

      if (targetData.date && !this.isDisabled(event)) {
        this.isMouseDown = true; // 记录按下的日期

        this.startData = (0, _spauiUtils.objectAssign)(targetData);
        this.endData = (0, _spauiUtils.objectAssign)(targetData);
      }
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      var targetData = this.getTargetData(event); // 非禁用且有日期的才能按下去

      if (this.isMouseDown === true && !this.isDisabled(event)) {
        // 不等于开始日期，就要更新选中状态
        if (targetData.date && !this.isEqualForObjectData(targetData, this.endData)) {
          this.endData = (0, _spauiUtils.objectAssign)(targetData);
          this.updateSelection(this.startData, this.endData);
        }
      }
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(event) {
      // 结束拖选
      if (this.isMouseDown === true && !this.isDisabled(event)) {
        this.endSelection();
      }
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave(event) {
      // 离开的时候也要去掉拖选
      this.handleMouseUp(event);
    } // 更新选中态

  }, {
    key: "updateSelection",
    value: function updateSelection(startData, endData, callback) {
      var _this$props3 = this.props,
          type = _this$props3.type,
          value = _this$props3.value,
          keyday = _this$props3.keyday,
          format = _this$props3.format;
      var valueList = this.getRoutineList({
        value: value,
        format: format
      });
      var keydayList = this.getRoutineList({
        value: keyday,
        format: format
      });
      var listData = this.getRoutineListByStartAndEndData(startData, endData);
      var newValueList = {};
      var newKeyDayList = {};
      var key = '';

      if (type === 'keyday') {
        for (key in keydayList) {
          if (keydayList[key] && !listData[key]) {
            newKeyDayList[key] = (0, _spauiUtils.objectAssign)(keydayList[key]);
          }
        }

        for (key in listData) {
          if (listData[key] && !keydayList[key]) {
            newKeyDayList[key] = (0, _spauiUtils.objectAssign)(listData[key]);
          }
        }

        this.setState({
          keydayList: newKeyDayList
        }, function () {
          if ((0, _spauiUtils.isFunction)(callback)) {
            callback();
          }
        });
      } else {
        for (key in valueList) {
          if (valueList[key] && !listData[key]) {
            newValueList[key] = (0, _spauiUtils.objectAssign)(valueList[key]);
          }
        }

        for (key in listData) {
          if (listData[key] && !valueList[key]) {
            newValueList[key] = (0, _spauiUtils.objectAssign)(listData[key]);
          }
        }

        this.setState({
          valueList: newValueList
        }, function () {
          if ((0, _spauiUtils.isFunction)(callback)) {
            callback();
          }
        });
      }
    }
  }, {
    key: "endSelection",
    value: function endSelection() {
      var _this3 = this;

      this.updateSelection((0, _spauiUtils.objectAssign)(this.startData), (0, _spauiUtils.objectAssign)(this.endData), function () {
        _this3.handleChange();

        _this3.setState({
          valueList: _this3.getRoutineList({
            value: _this3.props.value,
            format: _this3.props.format
          }),
          keydayList: _this3.getRoutineList({
            value: _this3.props.keyday,
            format: _this3.props.format
          })
        });
      });
      this.startData = {};
      this.endData = {};
      this.isMouseDown = false;
    } // 获取上个月的日期数据

  }, {
    key: "getLastMonthDateData",
    value: function getLastMonthDateData() {
      var _this$props4 = this.props,
          year = _this$props4.year,
          month = _this$props4.month;
      var firstDayOfWeek = new Date(year, month, 1).getDay();
      var result = [];
      var lastDays = 0;
      var lastYear = 0;
      var lastMonth = 0;
      var i = 0;
      var itemData = {}; // 上个月的日期，默认都为false

      if (firstDayOfWeek > 0) {
        if (month === 0) {
          lastYear = year - 1;
          lastMonth = 11;
        } else {
          lastYear = year;
          lastMonth = month - 1;
        }

        lastDays = new Date(lastYear, lastMonth + 1, 0).getDate();

        for (; i < firstDayOfWeek; i++) {
          itemData = {
            lastMonth: true,
            disabled: true,
            year: lastYear,
            month: lastMonth,
            date: lastDays - i
          };
          result.unshift(itemData);
        }
      }

      return result;
    } // 获取下个月的日期

  }, {
    key: "getNextMonthDateData",
    value: function getNextMonthDateData() {
      var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var _this$props5 = this.props,
          year = _this$props5.year,
          month = _this$props5.month;
      var result = [];
      var i = 0;
      var nextYear = 0;
      var nextMonth = 0;
      var itemData = {};

      if (len > 0) {
        if (month === 11) {
          nextYear = year + 1;
          nextMonth = 0;
        } else {
          nextYear = year;
          nextMonth = month + 1;
        }

        for (; i < len; i++) {
          itemData = {
            nextMonth: true,
            year: nextYear,
            month: nextMonth,
            disabled: true,
            date: i + 1
          };
          result.push(itemData);
        }
      }

      return result;
    } // 生成日期面板

  }, {
    key: "genDateList",
    value: function genDateList() {
      var _this4 = this;

      var _this$props6 = this.props,
          year = _this$props6.year,
          month = _this$props6.month,
          optionalStartDateData = _this$props6.optionalStartDateData,
          optionalEndDateData = _this$props6.optionalEndDateData;
      var thisMonthTheDate = new Date(year, month + 1, 0); // 这个月有多少天

      var thisMonthDays = thisMonthTheDate.getDate(); // 当前是哪天

      var isDisabled = function isDisabled(curYear, curMonth, date) {
        var theDate = new Date(curYear, curMonth, date).getTime();
        var optionalStartDate = new Date(optionalStartDateData.year, optionalStartDateData.month, optionalStartDateData.date).getTime();
        var optionalEndDate = new Date(optionalEndDateData.year, optionalEndDateData.month, optionalEndDateData.date).getTime();
        var result = false;

        if (theDate < optionalStartDate) {
          result = true;
        } else if (theDate > optionalEndDate) {
          result = true;
        }

        return result;
      };

      var result = this.getLastMonthDateData();
      var i = 0; // 这个月的日期，都为可用数据

      i = 0;

      for (; i < thisMonthDays; i++) {
        result.push({
          year: year,
          month: month,
          disabled: isDisabled(year, month, i + 1),
          date: i + 1
        });
      }

      result = result.concat(this.getNextMonthDateData(42 - result.length));
      return _react["default"].createElement("ul", {
        className: "datelist clearfix",
        onMouseDown: this.handleMouseDown,
        onMouseMove: this.handleMouseMove,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseLeave
      }, result.map(function (item) {
        var itemStatus = _this4.getDateStatus(item);

        var aProps = {
          'data-year': item.year,
          'data-month': item.month,
          'data-date': item.date,
          'data-disabled': item.disabled ? 1 : ''
        };
        var liClassName = (0, _classnames["default"])({
          disabled: item.disabled,
          on: itemStatus === 'on',
          among: itemStatus === 'among' || itemStatus === 'keyday',
          keyday: itemStatus === 'keyday'
        });
        return _react["default"].createElement("li", {
          key: "".concat(item.year, "_").concat(item.month, "_").concat(item.date),
          className: liClassName
        }, _react["default"].createElement("a", aProps, item.date));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          year = _this$props7.year,
          month = _this$props7.month;
      return _react["default"].createElement("div", {
        className: "spaui-datepicker"
      }, _react["default"].createElement("div", {
        className: "date-dropdown"
      }, _react["default"].createElement("div", {
        className: "datearea monthlist"
      }, _react["default"].createElement("div", {
        className: "ymchoose"
      }, _react["default"].createElement("div", {
        className: "ymselect"
      }, year, "\u5E74", month + 1, "\u6708")), _react["default"].createElement("div", {
        className: "dateitem"
      }, _react["default"].createElement("ul", {
        className: "weeklist"
      }, ['日', '一', '二', '三', '四', '五', '六'].map(function (item, index) {
        return _react["default"].createElement("li", {
          key: index
        }, item);
      })), this.genDateList()))));
    }
  }]);

  return MonthArea;
}(_react.PureComponent);

_defineProperty(MonthArea, "propTypes", {
  value: _spauiUtils.PropTypes.array,
  keyday: _spauiUtils.PropTypes.array,
  onChange: _spauiUtils.PropTypes.func,
  year: _spauiUtils.PropTypes.number.isRequired,
  month: _spauiUtils.PropTypes.number.isRequired,
  optionalStartDateData: _spauiUtils.PropTypes.object,
  optionalEndDateData: _spauiUtils.PropTypes.object,
  disabled: _spauiUtils.PropTypes.bool,
  format: _spauiUtils.PropTypes.string,
  type: _spauiUtils.PropTypes.string
});

_defineProperty(MonthArea, "defaultProps", {
  value: [],
  keyday: [],
  year: 0,
  month: 0,
  optionalStartDateData: {},
  optionalEndDateData: {},
  disabled: false,
  format: 'XXXX-XX-XX',
  type: ''
});

var _default = MonthArea;
exports["default"] = _default;